import React from "react";

import styles from "./index.module.scss";

interface IProps {
    className?: string;
}

export const SVGLoader = (props: IProps): React.JSX.Element => {
    return (
        <div className={`${styles.container} ${props.className || ""}`}></div>
    );
};
